import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { CustomerService } from '../../../services/customer.service';
import { AccountService } from '../../../services/account.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-create-quick-account-type-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './create-quick-account-type-lookup.component.html',
  styleUrl: './create-quick-account-type-lookup.component.scss'
})
export class AccountTypeLookupComponent implements OnInit {
  @Output() AccountTypeId = new EventEmitter<any>();
  constructor(  private ref: DynamicDialogRef,private messageService: MessageService, private accountServices: AccountService, private customerService: CustomerService) { }

  submitted: boolean = false;
  loader: boolean = false;
  stateList: any[] = [];
  filterStates: any[] = [];

  accountTypeForm = new FormGroup({
    AccountTypeCode: new FormControl('', Validators.required),
    // AccountTypeName: new FormControl(),
    manualEntry: new FormControl(true),
    AccountTypeDescription: new FormControl(),
    AccountType: new FormControl('', Validators.required),
    isActive: new FormControl(true),
    createdBy: new FormControl(''),
    upatedBy: new FormControl('')
  });

  ngOnInit(): void {

  }

  get formControls() {
    return this.accountTypeForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.accountTypeForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

  checkAccountTypeCode() {
    if (!this.accountTypeForm.controls.AccountTypeCode.value) {
      return;
    }

    this.accountServices.checkAccountTypeCode(this.accountTypeForm.controls.AccountTypeCode.value).subscribe(
      (data: any) => {
        if (data.success == true) {
          // console.log(data);
        } else {
          this.accountTypeForm.controls.AccountTypeCode.setValue('');
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
          this.accountTypeForm.controls.manualEntry.setValue(true);
        }
      },
      (error: any) => {
        console.log(error);
      });

  }

  manualEntry() {
    const manualEntryValue = this.accountTypeForm.controls.manualEntry.value;
    if (manualEntryValue === true) {
      this.accountTypeForm.controls.AccountTypeCode.setValue('');
    } else {
      this.getAccountTypeCode();
    }
  }

  getAccountTypeCode() {
    this.loader = true;
    this.accountServices.autogenerateAccountTypeCode().subscribe({
      next: (data: any) => {
        const alphanumericCode = '';
        const AccountGroupCode = alphanumericCode + data;
        this.accountTypeForm.controls.AccountTypeCode.setValue(AccountGroupCode);
        this.loader = false;
      },
      error: (error: any) => {
        console.log(error);
        this.loader = false;
      }
    });
  }


  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }


  createAccountGroup(): void {
    this.submitted = true;

    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }
    const formData = this.accountTypeForm.value;
    //   if (!formData.AccountType) {
    //   formData.AccountType = '123';  
    // } else if (Array.isArray(formData.AccountType)) {
    //   formData.AccountType = formData.AccountType[0];  
    // }

    // if (typeof formData.isActive === 'string') {
    //   formData.isActive = formData.isActive === 'true'; 
    // }

    const username = localStorage.getItem('username');
    if (username) {
      formData.createdBy = username;
      formData.upatedBy = username;
    } else {
      console.error('Username not found in localStorage');
      return; 
    }
  
    this.loader = true;
  
    console.log('Submitting formData:', formData); 
    this.accountServices.createAccountType(formData).subscribe({
      next: (data: any) => {
        if (data && typeof data === 'number') {
          console.log('Created Account Group ID:', data);
          this.loader = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: `Account Type created successfully`
          });

          this.AccountTypeId.emit(data);
          this.ref.close(data);
        } else {
          this.loader = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: 'Failed to create the Account Type.'
          });
        }
      },
      error: (error: any) => {
        console.error('Error creating AccountType:', error);
        this.loader = false;
  
        // Log the error and provide a detailed message to the user
        if (error.error) {
          console.error('API error details:', error.error); // Log API error response
        }
  
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'An error occurred while creating the Account Type.'
        });
      }
    });
  }
  
  
  
}  